<template>
  <div class="flex justify-end">
    i am order
    <Skeleton></Skeleton>
  </div>
</template>

<script>
  import Skeleton from '../../components/global_UI/LoadingSkeleton'

  export default {
    name: 'OrdersIndex',
    components: {
      Skeleton
    }
  }
</script>

<style scoped>

</style>
